import { createServerFn } from '@tanstack/react-start';
import { getRequest } from '@tanstack/react-start/server';
import { z } from 'zod';

import type { InstrumentSearchQuoteResponseFiltered } from '~/integrations/yahoo/queries.d.ts';
import { searchPossibleAdditions } from '~/integrations/yahoo/queries.server.ts';

import { requireStartAuthSession } from '../auth/require-start-auth-session.ts';
import { createServerFnObservabilityMiddleware } from '../utils/create-instrumented-server-fn.ts';

const SearchNavbarInstrumentsSchema = z.object({
	query: z.string().trim().min(1).max(30),
});

export const searchNavbarInstruments = createServerFn({ method: 'GET' })
	.middleware([
		createServerFnObservabilityMiddleware({
			dependencies: ['auth.session', 'yahoo.search'],
			relatesTo: 'app.navbar-search',
		}),
	])
	.inputValidator(SearchNavbarInstrumentsSchema)
	.handler(async ({ data }): Promise<InstrumentSearchQuoteResponseFiltered> => {
		const request = getRequest();

		await requireStartAuthSession({
			onFailRedirectTo: '/auth/signin',
			request,
			verify: false,
		});

		const result = await searchPossibleAdditions(data.query);

		return (result?.quotes.filter((quote) => quote.symbol) ?? []) as InstrumentSearchQuoteResponseFiltered;
	});
